<div class="modal-content">
  <div class="text-right">
    <mat-icon (click)="onSubmit(false)">close</mat-icon>
  </div>
  <div class="content">
    <div class="row">
      <div class="col-md-6 form-group">
        <label>Vessel Name:</label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="vesselName"
          placeholder="Enter Vessel Name"
        />
      </div>

      <div class="col-md-6 form-group">
        <label>Vessel IMO:</label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="vesselIMO"
          placeholder="Enter Vessel IMO"
        />
      </div>
    </div>
  </div>
  <div class="text-center mt-4 d-flex justify-content-center gap-2">
    <button class="btn btn-light hover-clear clear" (click)="onSubmit(true)">
      <span class="namestwo">Submit</span>
    </button>
    <button class="btn btn-light hover-clear clear" (click)="onSubmit(false)">
      <span class="namestwo">Cancel</span>
    </button>
  </div>
</div>
